import { Switch } from "@headlessui/react";
import clsx from "clsx";
import Spinner from "@/ui-components/spinner";

interface SubscriptionToggleProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export function SubscriptionToggle({
  checked,
  onChange,
  disabled = false,
  loading = false,
}: SubscriptionToggleProps) {
  const isDisabled = disabled || loading;

  return (
    <div className="relative inline-flex items-center">
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={isDisabled}
        className={clsx(
          "group relative inline-flex w-12 p-1 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-squawk-blue focus-visible:ring-offset-2",
          "data-[checked]:bg-squawk-blue",
          isDisabled && "opacity-50 cursor-not-allowed"
        )}
      >
        <span className="sr-only">Toggle subscription</span>
        <span
          aria-hidden="true"
          className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
        >
          {loading && (
            <span className="absolute inset-0 flex items-center justify-center">
              <Spinner size="xs" />
            </span>
          )}
        </span>
      </Switch>
    </div>
  );
}
